import { Directive, ElementRef, Renderer2, Input, AfterViewInit } from '@angular/core';

@Directive({
    selector: '[appTDCell]'
})
export class TDCellDirective implements AfterViewInit {
    /**[0]=Classes to Add, [1]=Classes to Remove */
    // tslint:disable-next-line:no-input-rename
    @Input('appTDCell') inputs: string[][];

    constructor(private elementRef: ElementRef, private renderer: Renderer2) {

    }

    ngAfterViewInit() {
        let td: Node = null;
        const maxLevelsToGoUp = 5;
        let levelsAttemped = 0;
        td = this.elementRef.nativeElement;
        while (levelsAttemped < maxLevelsToGoUp) {
            if (!td) {
                break;
            }
            if (td.nodeName === 'TD') {
                break;
            }
            td = td.parentElement;
            levelsAttemped++;
        }
        if (td) {
            this.inputs[1].map(classToRemove => {
                this.renderer.removeClass(td, classToRemove);
            });
            this.inputs[0].map(classToAdd => {
                this.renderer.addClass(td, classToAdd);
            });
            this.renderer.setStyle(td, 'background-size', '50% 100%');
        }
    }
}
